import { css } from "@emotion/react";

import { COLORS } from "../../stylesheets/emotion/vars";
import image from "../images/roundabout/hash-extracts.jpg";
import horecaImage from "../images/roundabout/light-mode-beans.png";

export const roundAbout69StyleLightMultiScreen = css`
    body {
        overflow-y: hidden;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }

        height: 100vh;
        width: 100vw;
    }

    .pattern {
        display: none;
    }

    .logo {
        display: none;
    }

    .bannerAll {
        display: grid;
        grid-template-columns: auto auto auto;
    }

    .bannerBack {
        width: 17.5%;
        margin-top: 0.55vw;
        position: absolute;
        margin-left: 53.6%;
    }

    .bannerFront {
        width: 19%;
        margin-left: 27.3%;
        margin-top: 0.68vw;
        position: absolute;
    }

    .bannerLogo {
        width: 6.2vw;
        position: relative;
        margin-top: 0.1vw;
        margin-left: 125.7%;
        margin-bottom: -4.5vw;
        z-index: 1;
        filter: drop-shadow(0px 0px 5px #fff);
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg) scale(0.5);
            opacity: 0.4;
        }
        5% {
            transform: rotate(180deg) scale(0.5);
            opacity: 0.6;
        }
        10% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.4;
        }
        100% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.4;
        }
    }

    .logo {
        position: absolute;
        left: 10%;
        margin-top: 20vh;
        width: 80%;
        animation: rotation 25s 20s;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        filter: drop-shadow(0px 0px 10px #fff);
        opacity: 0.2;
        z-index: -1;
    }

    .menukaart {
        width: 99vw;
        height: 99vw;
        display: grid;
        grid-template-columns: auto auto auto;
        position: absolute;
        z-index: 1;
    }

    .menu {
        max-width: 45vw;
        margin-left: 1.9vw;
        margin-top: 3vw;
        position: relative;
    }

    .backgroundShadow {
        margin-top: 0.3vw;
        border-radius: 15px;
    }

    .info {
        display: flex;
        flex-direction: row-reverse;
    }

    .row {
        padding-top: 0;
        width: 99.8%;
        margin-left: 0.1vw;
        margin-bottom: 0;
        margin-top: 0;
        position: relative;
        z-index: 0;
    }

    .row:nth-child(even) {
        display: flex;
        padding-top: 0.05vw;
        position: relative;
        background-color: ${COLORS.roundaboutRowColor}EF;
    }

    .row:nth-child(odd) {
        display: flex;
        padding-top: 0.05vw;
        position: relative;
        background-color: ${COLORS.roundaboutRowColor2}EF;
    }

    .row:last-child {
        border-bottom-left-radius: 0.75vw;
        border-bottom-right-radius: 0.75vw;
    }

    .row:first-child {
        border-top-left-radius: 0.75vw;
        border-top-right-radius: 0.75vw;
    }

    .rowContent {
        padding: 0.12vw 0;
        display: flex;
    }

    .productkind {
        color: black;
        font-size: 0.9vw;
        margin-top: 0.3vw;
        width: 3vw;
        margin-left: 2vw;
    }

    .banner {
        width: 100%;
        margin-left: 8vw;
        margin-top: 1vw;
        position: relative;
    }

    @keyframes moveBackground {
        0% {
            background-position: 0 0;
            background-size: 100% 100%;
        }
        25% {
            background-position: 3% 6%;
            background-size: 110% 110%;
        }
        50% {
            background-position: 6% 9%;
            background-size: 115% 115%;
        }
        75% {
            background-position: 3% 2%;
            background-size: 110% 110%;
        }
        100% {
            background-position: 0 0;
            background-size: 100% 100%;
        }
    }

    .pagebackground::before {
        //animation: moveBackground 50s linear infinite;
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background-size: 150% 150%;
        background-image: inherit;
        background-repeat: no-repeat;
        background-position: center;
        filter: brightness(80%) contrast(200%) saturate(2);
        z-index: -1; /* Stays behind content */
    }

    .pagebackground {
        background-image: url("${image}");
        z-index: -10000;
    }

    .horecapagebackground::before {
        animation: moveBackground 50s linear infinite;
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background-size: 150% 150%;
        background-image: inherit;
        background-repeat: no-repeat;
        background-position: center;
        filter: brightness(80%) contrast(200%) saturate(2);
        z-index: -1; /* Stays behind content */
    }

    .horecapagebackground {
        background-image: url("${horecaImage}");
        z-index: -10000;
    }

    .redbg {
        position: absolute;
    }

    @font-face {
        font-family: "cordia";
        font-weight: normal;
        font-style: normal;
    }

    .categoryImage {
        display: block;
        min-height: 6vw;
        max-height: 6vw;
        width: auto;
        object-fit: contain;
        margin-top: 3vw;
        margin-bottom: 0.75vw;
        margin-left: 1.4vw;
        //filter: hue-rotate(240deg) saturate(70%) drop-shadow(0.3vw 0 #eaefe9) drop-shadow(-0.2vw 0.2vw #8c76c2) drop-shadow(0 0.3vw #e9dfee) drop-shadow(0 -0.3vw #eaefe9)
        filter: drop-shadow(0.2vw 0 #fdf9f9) drop-shadow(-0.2vw 0.2vw #e4d2ee) drop-shadow(0 0.2vw #e9dfee)
            drop-shadow(0 -0.2vw #f6f8f6);
    }

    .marginTopTitle {
        //margin-top: -8vw;
    }

    .titleNotAtTop,
    .title {
        margin-left: 0.6vw;
        font-size: 2.4vw;
        font-weight: 600;
        margin-top: 1vw;
        position: relative;
        width: 22vw;
        text-shadow: #ffffff 0.1vw 0.1vw;
        color: #8c76c2;
    }

    .particles {
        position: absolute;
        margin-left: 50vw;
        width: 300px;
    }

    .btn {
        position: absolute;
    }

    .kindBadge {
        margin: auto;
        padding: 0 0.65vw; //Padding between badge and namePrice
        z-index: 1;
    }

    .nameStar {
        display: flex;
    }

    .newBadge {
    }

    .nameprice {
        font-size: 1.7vw;
        text-transform: uppercase;
        color: black;
        font-weight: 600;
        z-index: 1;
        padding-block: 0.39vw;
    }

    .description {
        font-size: 0.75vw;
        color: ${COLORS.descriptionColor};
        margin: 0 auto;
        display: none;
    }

    .kind {
        font-size: 0.5vw;
        position: relative;
        margin-left: -2vw;
        margin-top: 0.5vw;
        width: 5vw;
        color: black;
    }

    .priceContainer {
        position: relative;
        left: 0.5vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .price {
        font-size: 1.5vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5vw;
        color: black;
        z-index: 1;
    }

    .oldPrice {
        font-size: 1vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5vw;
        color: black;
        z-index: 1;
        text-decoration: line-through;
    }

    .discountedPrice {
        font-size: 1.5vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5vw;
        color: red;
        font-weight: bold;
        z-index: 1;
    }

    .priceHeader {
        position: relative;
        left: 0.15vw;
        font-size: 1.5vw;
        text-shadow: #e8e5da 0.07vw 0.07vw;
        margin-top: -2vw;
        width: 4.8vw;
        font-weight: bold;
        color: #393d36;
    }

    .filler {
        flex-grow: 1;
    }

    .svg-inline--fa {
        margin-left: 20px;
        margin-top: 8px;
        font-size: 30px;
    }

    .legend {
        display: none;
    }

    .legendNew {
        position: absolute;
        bottom: 0;
        right: 0;
        color: black;
        font-weight: bold;
        font-size: 1.4vw;
    }

    .legendContainer {
        position: relative;
        padding: 1vw;
        width: 45vw;
        background-color: rgba(175, 175, 175, 0.7);
        border-radius: 0.5vw;
    }

    .priceGrid {
        display: flex;
        justify-content: center;
    }
`;
